import { render } from "./AssetTypeAddData.vue?vue&type=template&id=2a4e0cf2"
import script from "./AssetTypeAddData.vue?vue&type=script&lang=js"
export * from "./AssetTypeAddData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__